import type { GridSortItem } from 'types/graphql';

/**
 * Oldest first (id ascending): the order the unordered `findMany` list reads came back in, which every picker
 * listed. A `*Page` root with no `sortItems` answers newest first (`findManyPaginated.ts` ends on `id desc`), so a
 * picker that replaced such a read asks for this order to keep its first page, and its default option, unchanged.
 */
export const OLDEST_FIRST: GridSortItem[] = [{ field: 'id', sort: 'asc' }];

/**
 * Most recently updated first (`updatedAt desc`, then the page root's `id desc`): the order the document-template
 * list read in (`documentTemplateResolutionOrderBy`), so a template picker built on `documentTemplatePage` asks for it.
 */
export const RECENTLY_UPDATED_FIRST: GridSortItem[] = [{ field: 'updatedAt', sort: 'desc' }];
